import { render, staticRenderFns } from "./BindingAccountsList.vue?vue&type=template&id=72165e1c&scoped=true&"
import script from "./BindingAccountsList.vue?vue&type=script&lang=js&"
export * from "./BindingAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./BindingAccountsList.vue?vue&type=style&index=0&id=72165e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72165e1c",
  null
  
)

export default component.exports